var map = {
	"./ar.json": "2445",
	"./bn.json": "3e69",
	"./de.json": "15a2",
	"./en.json": "4c86",
	"./es.json": "4e5c",
	"./fr.json": "33f8",
	"./hi.json": "2b88",
	"./id.json": "e1dc",
	"./ja-JP.json": "8a42",
	"./km.json": "30f2",
	"./ko.json": "d980",
	"./my.json": "8319",
	"./pt.json": "b340",
	"./ru.json": "5dc0",
	"./sk.json": "9de0",
	"./th.json": "c2c9",
	"./vi.json": "a108",
	"./zh-Hans.json": "d826",
	"./zh-Hant.json": "0ee3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a537";